var styleDataHash = "04e2821c";
const injectCss = (() => {
  var css = `.pRfAt{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,8px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 6px 6px 0 rgba(22,45,61,.06),0 0 18px 0 rgba(22,45,61,.12));box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:fit-content;min-width:var(--ricos-internal-dropdown-modal-min-width,160px);overflow:hidden;padding-block:12px;width:fit-content;z-index:10}.pRfAt *,.pRfAt :after,.pRfAt :before{box-sizing:inherit}.pRfAt input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:480px){.pRfAt{width:100%}}}@container (width < 480px){.pRfAt{width:100%}}.kF5wJ{border-radius:12px;box-shadow:0 12px 30px 0 rgba(19,23,32,.1),0 0 0 0 rgba(19,23,32,0);color:#000;padding-block:0}.N3oTL{width:100%}.BPesx{--wds-side-panel-content-padding-vertical:12px;--wds-side-panel-content-padding-horizontal:0px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var dropdown_modal_default = {
  "root": "pRfAt",
  "wixel": "kF5wJ",
  "mobile": "N3oTL",
  "mobileContent": "BPesx"
};
export {
  dropdown_modal_default as default,
  injectCss
};
//# sourceMappingURL=dropdown-modal-scss.js.map
